<template>
	<div id="app" class="container">
		<div class="header-nav" v-if="$route.meta.head">
			<headerNav :title="title" />
		</div>
		<keep-alive><router-view v-if="$route.meta.keepAlive"  :refreshobj="refresh" ></router-view></keep-alive>
		<router-view @fatherMethod="changetitle" v-if="!$route.meta.keepAlive && isRouterActive"  @refresh="refreshIt" />
		<div class="tab-bar">
			<Tabbar v-if="$route.meta.tabbar" />
		</div>
	</div>
</template>
<script>
	import Tabbar from './components/tabBar/index'
	import headerNav from './components/headerNav/index'
	import { mapState, mapMutations } from "vuex";
	export default {
		name: 'App',
		components: {
			Tabbar,
			headerNav
		},
		data() {
			return {
				isRouterActive:true,
				title:this.$route.meta.title,
				refresh:"no"  ,//其他页面可能要与keep-alive缓存的页面通讯，this.$emit('refresh');
			}
		},
		provide(){
			return {
				//刷新当前页面的方法
				reload:this.reload
			}
		},
		computed: {
		  ...mapState(["identity"]),
		},
		mounted() {
      console.log('test')
			// 0未认证  2：房主认证  20：待审核 
			// 本地测试修改code后sessionStorage.clear()一下，或者关闭页面后重进
			var to = location.href.split('to=')[1];
      var page = this.getRouteParam().page
      console.log(page)
			if (to) {
				sessionStorage.setItem('to', to)
			}
      if (page) {
				sessionStorage.setItem('to', page)
        if (page === 'gs') {
          this.getRouteParam().id && sessionStorage.setItem('gsId', this.getRouteParam().id)
        }
        if (page === 'jctp') {
          this.getRouteParam().id && sessionStorage.setItem('jctpId', this.getRouteParam().id)
        }
			}
			 if(this.fuc.getToken()){
				 this.changeIdentity(this.fuc.getIdentity()||'0');
			 }
			
			var type=this.fuc.getItem('type');
			var id=this.fuc.getItem('id');
			if(type&&Number(type)==1){
				// 直接打开决策投票详情页
				this.$router.push({ path: "/yzjc/vote", query: {id:id} });
			}else if(type&&Number(type)==2){
				// 直接打开维修金使用投票详情页
				this.$router.push({ path: "/user/toupiao2", query: {id:id} });
			}
		},
		watch:{
			$route(e){
				this.title=e.meta.title;
			}
		},
		methods: {
			 ...mapMutations(["changeIdentity","changeUserinfo"]),
      getRouteParam() { //获取问号参数
        var url = location.search
        // 获取url中'?'符后的字串
        var theRequest = {}
        if (url.indexOf('?') !== -1) {
          var str = url.substr(1)
          var strs = str.split('&')
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
          }
        }
        return theRequest
      },
			changetitle(e){
				this.title=e.title;
			},
			refreshIt() {
				this.refresh = 'yes';
			},
			reload(){
				this.isRouterActive = false
				this.$nextTick(function(){
					this.isRouterActive = true
				})
			},
		}
	}
</script>
<style lang="less">
	/*每个页面公共css */
	@import './styles/common.less';

	body {
		font-size: 16px;
		// color: #fff;
	}
	.container{
		background-color: #fff;
		min-height: 100% !important;
	}
	/* [class*='van-hairline']::after {
		border: none;
	} */

	.header-nav {
		width: 100%;
		height: 46px;
	}
</style>
